import React, {useEffect, useState} from 'react';
import Registration from "./components/Registration/Registration";
import PreAssessmentQuestions from "./components/Pre-AssessmentQuestions/Pre-AssessmentQuestions";
import Quiz from "./components/Quiz/Quiz";
import UserAnswers from "./components/UserAnswers/UserAnswers";
import Results from "./components/Results/Results";
import './App.css';
import Modal from "./components/Modal/Modal";
import {useTranslation} from "react-i18next";
import background from "./images/decor-circle.png";
import backgroundMobile from "./images/background-circle-mobile.png";

function App() {
    const { i18n } = useTranslation();

    const [currentStep, setCurrentStep] = useState<number>(0);
    const [answers, setAnswers] = useState([]);
    const [modalIsActive, setModalIsActive] = useState<boolean>(false);
    const [modalText, setModalText] = useState<string | null>(null);
    const [registrationFormFilled, setRegistrationFormFilled] = useState<boolean>(false);
    const [registrationData, setRegistrationData] = useState<any>();
    const [isMobileScreen, setIsMobileScreen] = useState(false);

    const setNewCurrentStep = (step: number): void => {
        setCurrentStep(step)
    }

    const openModal = (text: string) => {
        setModalIsActive(true)
        setModalText(text);
    }

    const closeModal = () => {
        setModalIsActive(false);
        setModalText(null);
    }

    useEffect( () => {
        if (document.body.clientWidth < 767) setIsMobileScreen(true);

        window.addEventListener("resize", () => {
            document.body.clientWidth < 767 ? setIsMobileScreen(true) : setIsMobileScreen(false);
        });

        // @ts-ignore
        i18n.changeLanguage(window.sanoLiving_globals?.language || 'fr');
    }, [])

    return (
        <div className="App position-relative">

            {
                !modalIsActive &&
                <div className="app-body">
                    {
                        currentStep === 0 &&
                        <Registration
                            setNewCurrentStep={setNewCurrentStep}
                            openModal={openModal}
                            setRegistrationFormFilled={setRegistrationFormFilled}
                            registrationFormFilled={registrationFormFilled}
                            registrationData={registrationData}
                            setRegistrationData={setRegistrationData}
                            isMobileScreen={isMobileScreen}
                        />
                    }

                    {
                        currentStep === 1 &&
                        <PreAssessmentQuestions
                            handleBack={setNewCurrentStep}
                            setNewCurrentStep={setNewCurrentStep}
                            openModal={openModal}
                        />
                    }

                    {
                        (currentStep === 2 || currentStep === 3) &&
                        <div>
                            <div className={currentStep === 3 ? 'd-none' : ''}>
                                <Quiz
                                    setNewCurrentStep={setNewCurrentStep}
                                    setAnswers={setAnswers}
                                    isMobileScreen={isMobileScreen}
                                />
                            </div>

                            {
                                currentStep === 3 &&
                                <UserAnswers
                                    setNewCurrentStep={setNewCurrentStep}
                                    answers={answers}
                                    isMobileScreen={isMobileScreen}
                                />
                            }
                        </div>
                    }

                    {
                        currentStep === 4 &&
                        <Results />
                    }
                </div>
            }

            {
                modalIsActive &&
                <Modal
                    closeModal={closeModal}
                    text={modalText}
                />
            }
        </div>
    );
}

export default App;
